module.exports = __webpack_public_path__ + "info.png?56673bb477b982595565e120414eac90";